export enum PlatformSource {
  /** 网页 */
  Web = 3,
  /** 移动端 */
  Mobile = 2,
}
